/* *** This is an automatically-generated file. DO NOT HAND-EDIT! ***
 *
 * Generated by jack@mimas on Tue Mar 17 2026 16:49:09 GMT-0400 (Eastern Daylight Time) via
 * "/usr/bin/node" "/home/jack/src/dcp-client/.dcp-build/ormdb/generate-schema" "../src/dcp-client/jnu/generated/schemas/blank.js" "db-schema.template" "schemas/blank.ormdb"
 */
/**
 * @file        db-schema.template
 *              Template file for the schema used by any non-database interfacing application (e.g. web code)
 * @author      Wes Garland, wes@kingsds.network
 * @date        March 2012, June 2021, July 2023
 */
'use strict';

/* our generic backend that doesn't do anything is called "db". We use these db schemas in dcp-client
 * when we need to reason about the database schema.
 */
exports.type = 'db';

const types = require('dcp/types');
exports.classes = {
  BigNumber: types.BigNumber,
  Address:   types.Address,
  DcpURL:    types.DcpURL,
};

exports.serializers = {
  JSON: globalThis.JSON,
  KVIN: new (require('kvin').KVIN)(),
};

/**
 * @file        schema-common.part
 *              Common schema components for all database types; gets injected into COMMON section
 *              of dbms-specific templates
 *
 * @author      Wes Garland, wes@distributive.network
 * @date        Jun 2021, Aug 2023
 */

const { BigNumber, Address, DcpURL } = exports.classes;
const { JSON, KVIN } = exports.serializers;

/**
 * ColumnType constructor. Instances of ColumnType define the types which are available to the ORM
 * client code. These definitions are further specialized in per-dbms schema definitions, to define how
 * these JS values are stored in the dbms and vice-versa.
 *
 * ColumnType properties include
 * - isKey:             this column is a key column. Key columns cannot be defined to have the value
 *                      undefined in the prototype, and only key columns can be foreign keys.
 * - primaryKey:        this column is the primary key
 * - uniqueConstraint:  this column has a unique constraint
 * - notNullConstraint: this column has a not-null constraint
 * - timestamp:         this column holds timestamps which are represented as either 'javascript' or
 *                      'unix' values to the JS code, depending on the value of the field
 * - autoIncrement:     this column holds values which automatically increment. Ormdb does not require
 *                      sequential values, nor an absolutely-strict insertion order.
 * - autoValue:         this column's value is recalculated, based on the value of this function, for
 *                      every insert or change
 * - caseInsensitive:   this column's values are compared caseinsensitively in WHERE clauses, grouping,
 *                      and ordering
 *
 * @param {string|Function}  typeHint    [optional] type name (eg 'string') for JS representation, or a
 *                                       constructor which can be use to convert between the JS type and
 *                                       string via ctor argument and string-coercion. If no typeHint is
 *                                       specified, it is assumed that both the JS and dbms types are
 *                                       compatible strings.
 * @param {object}           extras      [optional] extra properties to set on the column type declaration
 */
function ColumnType(description, typeHint, extras)
{
  this.description = description;
  this.sqlType = false; /* define later */

  /* handle overload */
  if (typeof typeHint === 'object')
  {
    extras = typeHint;
    typeHint = undefined;
  }

  if (typeof extras === 'object' && Object.values(exports.serializers).includes(extras))
  {
    /* No type hint, but extras is a serializer object like JSON */
    const { stringify, parse, ...restOfExtras } = extras;
    const serializer = extras;
    assert(typeHint === undefined);
    assert(typeof stringify === 'function');
    assert(typeof parse     === 'function');
    this.fromStorage = s => s === null ? null : serializer.parse(s);
    this.toStorage   = o => o === null ? null : serializer.stringify(o);
    this.isValueObject = true; /* don't parse as SVO, VDO */

    extras = restOfExtras;
  }
  else if (typeof typeHint === 'function')
  {
    /* Type hint is a constructor that trivially goes to/from string (like URL); assumes backing storage
     * is a string -- dbms-specific schemas can always override this.
     */
    const Ctor = typeHint;
    this.fromStorage = s => s === null ? null : new Ctor(s);
    this.toStorage   = v => v === null ? null : String(v);
  }
  else if (typeof typeHint !== 'undefined')
  {
    /* Type hint is the name of an intrinsic that trivially goes to/from string (like 'number'); assumes
     * backing storage is a string -- dbms-specific schemas can always override this.
     */
    assertInList(typeHint, 'boolean', 'number', 'string', 'bigint');
    this.jsType = typeHint;
  }

  Object.assign(this, extras);
}

/**
 * Return an instance of a new column type which is the same as "this" one, but having a default value.
 * @see ColumnType.prototype.with
 * @param defaultValue    the default value, in backing-database representation; used by the dbms-iface
 *                        library and not the ormdb API. In a SQL database, this value will be used to
 *                        specify the DEFAULT value in the table schema.
 */
ColumnType.prototype.default = function ColumnType$default(defaultValue)
{
  assert(typeof defaultValue !== 'undefined');
  return this.with({defaultValue: defaultValue});
}

/**
 * Return a new column type which is the same as "this" one, but which is not allowed to be null.
 * @see ColumnType.prototype.with
 */
ColumnType.prototype.notNull = function ColumnType$default()
{
  return this.with({ notNullConstraint: true });
}

/**
 * Return a new column type which is the same as "this" one, but with the specified extras. The new
 * will have the same description, meaning that the two types are "related" and the backing stores
 * must be compatible (modulo constraints etc).
 */
ColumnType.prototype.with = function ColumnType$with(extras)
{
  var newCT = Object.create(this);
  Object.assign(newCT, extras);
  return newCT;
}

/**
 * Flattens a column type, breaking heritable traits. Implemented primarily to make these objects easier
 * to inspect, but could be used as "extras" argument of the ctor.
 */
ColumnType.prototype.flatten = function ColumnType$flatten()
{
  const flat = {};

  for (let prop in this)
    if (!ColumnType.prototype.hasOwnProperty(prop))
      flat[prop] = this[prop];

  return flat;
}

/** Returns true when this instance of ColumnType was specialized from colType (ciString is a string) */
ColumnType.prototype.isA = function ColumnType$isA(colType)
{
  const thisProto = Object.getPrototypeOf(this);

  if (!(colType instanceof ColumnType))
    throw new Error('invalid column type');
  if (colType === this)
    return true;
  if (thisProto.constructor !== ColumnType)
    return false;

  return thisProto.isA(colType);
}

/** Declare a primary key */
function primary(colType)
{
  return colType.with({ primaryKey: true, isKey: true });
}

/** Declare a column type which holds either unique or NULL values */
function uniqueOrNull(colType)
{
  return colType.with({ uniqueConstraint: true });
}

/** Declare a column type which holds unique non-NULL values */
function unique(colType)
{
  return colType.with({ uniqueConstraint: true, notNullConstraint: true });
}

/** Declare a column which is an index. */
function index(colType)
{
  return colType.with({ isIndex: true });
}

/* Related column types have the same description. Unrelated column types must not. This equivalence may
 * be used programmatically to discover distinct column types whose values are interchangeable, modulo
 * constraints.
 *
 * ColumnType definitions here may specify the JS storage type and generally should. This will cause the
 * dbms-specific code to coerce from storage format into the correct JS representation. If a constructor
 * is provided here, it is assumed that the constructor accepts a string and returns the correct JS
 * type, and that coercing the resultant type to String will yield something suitable for the storage
 * backend. Similar automatic storage transformations will happen if an function is object is provided
 * which has properties named 'stringify' and 'parse'.  Storage<>JS transformations with more storage
 * specificity can also be added to these objects in ${dbms}-schema.template. Modifying a "root" column
 * type will also modify the derived column names via prototypal inheritance. For example, specifying
 * storage details for int53 will also specify the storage details for id, uniqueId, foreignId, etc.
 */
const ct = exports.columnTypes = {};
const int53      = ct.int53         = new ColumnType('Integers up to 53 bits',             'number'); /* Safely stores the entire range of JavaScript integers */
const id         = ct.id            =   int53.with({ isKey: true });
const uniqueId   = ct.uniqueId      =     unique(id);
const primaryId  = ct.primaryId     =     primary(id);
const autoId     = ct.autoId        =       primaryId.with({ autoIncrement: true });
const unixTime   = ct.unixTime      = new ColumnType('s since the epoch',                  { timestamp: 'unix' });
const timestamp  = ct.timestamp     = new ColumnType('ms since the epoch',                 { timestamp: 'javascript' });
const autoNow    = ct.autoNow       =   timestamp.with({ autoValue: (sb) => sb.svoCache.now || new Date(), notNullConstraint: true });
const string     = ct.string        = new ColumnType('UTF-8 strings up to 256 bytes',      'string');
const ciString   = ct.ciString      =   string.with({ caseInsensitive: true });
const identifier = ct.identifier    =   string.with({ identifier: true });
const opaqueId   = ct.opaqueId      =     identifier.with({ length: 22 });
const string64k  = ct.string64k     = new ColumnType('UTF-8 strings up to 64K bytes',      'string');
const stringUB   = ct.stringUB      = new ColumnType('Effectively unbounded strings',      'string');
const boolean    = ct.bool          = new ColumnType('true or false',                      'boolean');
const integer    = ct.integer       = new ColumnType('Integers up to 32 bits',             'number');
const uinteger   = ct.uinteger      = new ColumnType('Unsigned integers up to 32 bits',    'number');
const tinyInt    = ct.tinyInt       = new ColumnType('Integers up to 8 bits',              'number');
const tinyUint   = ct.tinyUint      = new ColumnType('Unsigned Integers up to 8 bits',     'number');
const float      = ct.float         = new ColumnType('64-bit IEEE 758 64-bit numbers',     'number');
const bigInt     = ct.bigInt        = new ColumnType('Arbitrary precision integers',       'bigint');
const finNum     = ct.finNum        = new ColumnType('Financial quantity (for DCC)');
const URI        = ct.URI           = new ColumnType('URL or data: URI',                   'string');
const url        = ct.url           = new ColumnType('URL',                                URL);
const json       = ct.json          = new ColumnType('JSON data',                          JSON);
const kvin       = ct.kvin          = new ColumnType('KVIN data',                          KVIN);
const ethAddress = ct.ethAddress    = new ColumnType('Ethereum address',                   Address);
const autoAddress = ct.autoAddress  =   ethAddress.with({ autoValue: (stmtBuilder) => {
  /* autoAddress is always populated with the address of the accessor when there is a security policy in
   * place, or the address which corresponds to the caller's identity if not.
   */
  if (stmtBuilder.securityPolicy === false)
    return stmtBuilder.selfId.address;
  else
    return stmtBuilder.accessor;
}});

/* Reflect views as tables so they can be queried with select() etc. Code that needs to
 * differentiate between tables and views should check !view(check) && table(check) to
 * know if check is a table.
 */
for (const v in exports.views)
{
  if (exports.tables[v])
    throw new Error('cannot have a view and a table with the same name.');
  exports.tables[v] = exports.views[v];
}

/** Throws when expr is falsey */
function assert(expr)
{
  if (!expr)
    throw new Error('assertion failure');
}

/** Throws when first argument not found in remaining argument list */
function assertInList(value, ...list)
{
  if (list.indexOf(value) === -1)
    throw new Error(`assertion failure; ${value} not in [${list.join(', ')}]`);
}

/**
 * Create a col def made up other col defs.  Column name collisions are resolved such that the
 * right-most definition has the highest precedence. A column defined as false will be dropped from the
 * final definition.
 */
function colDefCombine(...args)
{
  const res = Object.assign({}, ...args);
  for (let col in res)
    if (res[col] === false)
      delete res[col];
  return res;
}

/**
 * @file   blank.ormdb - A completely blank database schema. Once generated, a "blank" schema will
 *                       include all of the supporting structures (class, objects, etc) of a fully-
 *                       defined database schema.  This schema is primarily used for creating a 
 *                       template schema for jnu; jnu clients can then make web queries to get table
 *                       and view information from the server, while maintaining consistent class
 *                       and serializer definitions vis a vis instanceOf elsewhere in dcp-client.
 * @author Wes Garland, wes@distributive.network
 * @date   Nov 2024
 */

exports.tables  = {};
exports.views   = {};
exports.indices = {};
exports.label   = 'blank';

/**
 * @file        schema-epilogue.part
 *              Schema epilogue for all database types; gets injected into EPILOGUE section
 *              of dbms-specific templates
 *
 * @author      Wes Garland, wes@distributive.network
 * @date        Feb 2026
 */

exports.source = { version: '${repo.sha}', branch: '${repo.branch}', filename: '${master_schema}' };
exports.build = { date: '${Date()}', machine: '${os.hostname}', user: '${USER}', filename: '${output_file}' };

/**
 * Add a wrapper to the fromStorage functions so that bad input in the database doesn't crash the application;
 * instead, the value "undefined" is returned, which should be impossible to get any other way.
 */
for (let ct of Object.values(exports.columnTypes))
{
  if (ct.fromStorage)
  {
    const fromStorage = ct.fromStorage;
    ct.fromStorage = function fromStorageWrapper() {
      try
      {
        return fromStorage.apply(this, arguments);
      }
      catch(error)
      {
        return undefined;
      }
    };
  }
}


